import DashboardLayout from "src/layouts/dashboard";
import CashGifts from "./CashGifts";
import styles from "./wallet.module.scss";

function Wallet() {
  return (
    <DashboardLayout pageName="Cash Gifts">
      <div className={styles["wallet"]}>
        <div className={styles["wallet__main"]}>
          <CashGifts />
          {/* <NairaWallet /> */}
        </div>
      </div>
    </DashboardLayout>
  );
}

export default Wallet;
